// extracted by mini-css-extract-plugin
export var breakpointLG = "1280px";
export var breakpointMD = "1024px";
export var breakpointSM = "768px";
export var breakpointXL = "1440px";
export var breakpointXS = "480px";
export var breakpointXXL = "2048px";